import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";



const UserList = () => {
  const navigate = useNavigate();


  const users = [
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      address: "Pune, Maharashtra",
      totalOrder: 12,
      loalityPoints: 120,

    },
    {
      id: 2,
      name: "John Smith",
      email: "john@example.com",
      phone: "+91 9000011111",
      address: "Mumbai, Maharashtra",
      totalOrder: 8,
      loalityPoints:20,

    },
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User Detail </TableCell>
       
              <TableCell>Address</TableCell>
              <TableCell>Total Order</TableCell>
              <TableCell>Loyality Points</TableCell>

              <TableCell>Enable / Disable</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {users.map((user) => (
              <TableRow hover key={user.id}>
                <TableCell
                  className="click_action"
                 
                >
                       <a
                 
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail");
                    }}
                    className="user_block click_action"
                  >
                    <figure>
                      <img src="/static/images/user_placeholder.png" alt="User" />
                    </figure>
                    <p><b>{user.name}</b>  <span>{user.phone}</span>  <span>{user.email}</span> </p>
                  </a>
                </TableCell>



                <TableCell>{user.address}</TableCell>

                <TableCell>{user.totalOrder}</TableCell>
                <TableCell> <span className="status_btn dark c_success"> {user.loalityPoints}</span></TableCell>


                <TableCell>
                  <SwitchToggle />
                </TableCell>

                <TableCell>
                  <div className="table_actions v2">
                    <IconButton
                      onClick={() =>
                        navigate("/manage-users/detail", { state: { user } })
                      }
                    >
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>
                    <IconButton
                      onClick={() =>
                        navigate("/manage-users/add", { state: { user } })
                      }
                    >
                      <img src="/static/images/edit2_icon.svg" alt="View" />
                    </IconButton>

                    <IconButton >
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    
    </>
  );
};

export default UserList;
